export function addEthnio(ethnioCode: number): void {
    const script = document.createElement('script');
    script.async = true;
    script.src = `//ethn.io/${ethnioCode}.js`;
    script.type = 'text/javascript';
    document.body.appendChild(script);
}

export function removeEthnio(ethnioCode: number): void {
    const scriptElement = document.querySelector(`script[src="//ethn.io/${ethnioCode}.js"]`);

    if (scriptElement) {
        scriptElement.remove();
    }

    const ethnioPopup = document.querySelector(`div[id="ethnio-campaign-theme"]`);

    if (ethnioPopup) {
        ethnioPopup.remove();
    }
}
